import type { MoveOutcome, MomentumMetric, InterventionOutcome } from '../types';

export const DEFAULT_MOMENTUM: MomentumMetric[] = [
  { key: 'moves_completed', label: 'Moves completed', count: 0, lifetime: 0 },
  { key: 'urges_interrupted', label: 'Urges interrupted', count: 0, lifetime: 0 },
  { key: 'hard_days_honest', label: 'Hard days owned', count: 0, lifetime: 0 },
  { key: 'protected_hours', label: 'Protected hours', count: 0, lifetime: 0 },
];

const bump = (metrics: MomentumMetric[], key: string, by = 1): MomentumMetric[] =>
  metrics.map((m) =>
    m.key === key
      ? { ...m, count: m.count + by, lifetime: m.lifetime + by }
      : m,
  );

/**
 * Momentum never resets on a skip or hard day.
 * Lapses add honesty metrics; they do not erase lifetime progress.
 */
export const applyMoveToMomentum = (
  metrics: MomentumMetric[],
  outcome: MoveOutcome,
  moveId?: string,
): MomentumMetric[] => {
  let next = metrics.length ? metrics : [...DEFAULT_MOMENTUM];

  if (outcome === 'complete') {
    next = bump(next, 'moves_completed');
    if (moveId === 'gotg_d5') {
      next = bump(next, 'protected_hours');
    }
  } else if (outcome === 'hard') {
    next = bump(next, 'hard_days_honest');
  }
  // skip: no penalty, no erasure
  return next;
};

export const applyInterventionToMomentum = (
  metrics: MomentumMetric[],
  outcome: Pick<InterventionOutcome, 'helped'>,
): MomentumMetric[] => {
  let next = metrics.length ? metrics : [...DEFAULT_MOMENTUM];
  if (outcome.helped === true) {
    next = bump(next, 'urges_interrupted');
  }
  return next;
};

/** Explicit: never wipe metrics on lapse / new enrollment / skip. */
export const mergeMomentumOnLapse = (metrics: MomentumMetric[]): MomentumMetric[] =>
  metrics.map((m) => ({ ...m })); // identity — documented no-op for tests
